import * as yup from 'yup';
import { makeEmptyStringNull } from '../utils/makeEmptyStringNull';

export const PaginatedResponseMetaSchema = yup.object({
  next_token: yup.string().transform(makeEmptyStringNull).nullable().defined(),
  prev_token: yup.string().nullable(),
});

export type PaginatedResponseMeta = yup.InferType<
  typeof PaginatedResponseMetaSchema
>;
